/**
 * What an Access Pass unlocks, derived from the plan's limits/features from the server
 */

const LABELS = {
  en: {
    unlimited: 'Unlimited estimates & calculations',
    save: 'Save projects',
    saveN: 'Save up to {n} projects',
    compare: 'Compare scenarios',
    pdf: 'PDF reports',
  },
  my: {
    unlimited: 'Anggaran & pengiraan tanpa had',
    save: 'Simpan projek',
    saveN: 'Simpan sehingga {n} projek',
    compare: 'Bandingkan senario',
    pdf: 'Laporan PDF',
  },
};

export const getPlanBenefits = (plan, language = 'en') => {
  const t = LABELS[language] || LABELS.en;
  const limits = plan.limits || {};
  const features = plan.features || {};
  const out = [];
  if (limits.daily_quick_estimates === -1 || features.unlimited_estimates) out.push(t.unlimited);
  if (limits.max_saved_projects === -1) out.push(t.save);
  else if (limits.max_saved_projects > 0) out.push(t.saveN.replace('{n}', limits.max_saved_projects));
  if (limits.can_compare_scenarios || features.compare_scenarios) out.push(t.compare);
  if (limits.can_export_pdf || features.pdf_export) out.push(t.pdf);
  return out;
};
